import { Button } from "@/components/ui/button";
import { LayoutList, Table2 } from "lucide-react";

export type ViewMode = "grouped" | "flat";

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

/**
 * Segmented control for switching between grouped and flat ticket views.
 */
export function ViewModeToggle({ value, onChange }: ViewModeToggleProps) {
  return (
    <div className="flex items-center rounded-md border overflow-hidden">
      <Button
        variant={value === "grouped" ? "default" : "ghost"}
        size="sm"
        type="button"
        className="rounded-none border-0 gap-1.5"
        onClick={() => onChange("grouped")}
        aria-pressed={value === "grouped"}
      >
        <LayoutList className="h-4 w-4" />
        Grouped
      </Button>
      <div className="w-px bg-border h-6" />
      <Button
        variant={value === "flat" ? "default" : "ghost"}
        size="sm"
        type="button"
        className="rounded-none border-0 gap-1.5"
        onClick={() => onChange("flat")}
        aria-pressed={value === "flat"}
      >
        <Table2 className="h-4 w-4" />
        Flat
      </Button>
    </div>
  );
}
